import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, scan } from 'rxjs/operators';
import { ApiService, IListParams } from '../services/api/api/api.service';
export interface List1 {
  list: [];
  totalCount: number;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CUSTOM_SELECT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  useExisting: forwardRef(() => LazySelectComponent),
  multi: true,
};

@Component({
  selector: 'app-lazy-select',
  templateUrl: './lazy-select.component.html',
  styleUrls: ['./lazy-select.component.scss'],
  providers: [CUSTOM_SELECT_CONTROL_VALUE_ACCESSOR],
})
export class LazySelectComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  // TODO -remove devFlag on lazy select fix;
  devFlag = true;
  @Input() type: string;
  @Input() selectedVal = '';

  @Output() changeValue = new EventEmitter();
  // @Input() selected;
  @Input()
  public set selected(val: string) {
    // this.selected = val;
    this.populatePreSelect(val);
  }

  ctrl: UntypedFormControl = new UntypedFormControl(this.selectedVal);
  searchCtrl: UntypedFormControl = new UntypedFormControl();
  subscriptions: Subscription[] = [];
  count: any;
  list = [];
  endpoint: any;
  skip = 0;
  limit = 10;
  search = '';
  options$: Observable<any[]>;
  options = new BehaviorSubject<any[]>([]);
  paths = this._api.lazyPaths;

  constructor(private _api: ApiService) {
    this.options$ = this.options.asObservable().pipe(
      scan((acc, curr) => {
        return [...acc, ...curr];
      }, []),
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  writeValue(obj): void {
    // console.log(obj)
    if (this.selectedVal) {
      this.ctrl.setValue(this.selectedVal);
    } else {
      this.ctrl.setValue(obj);
    }
    // this.change(this.selected || obj || '');
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  ngOnInit(): void {
    if (this.type) {
      // if (this.selected) {
      // this.list.push(this.selected);
      // this.options.next([...this.options.getValue() , this.selected]);
      // }
      this.endpoint = this.paths.find((o) => o.name === this.type).path;
      const isData = this.paths.find((o) => o.name === this.type).data;
      const isLoading = this.paths.find((o) => o.name === this.type).isLoading;
      this.subscriptions.push(
        this._api.lazyPaths
          .find((o) => o.name === this.type)
          .data.subscribe((data) => {
            this.list = data;
            // added this to inform the parent component about the currently selected value
            this.change(this.ctrl.value);
          }),
      );

      if (this.endpoint && !isData.value && !isLoading) {
        this._api.lazyPaths.find((o) => o.name === this.type).isLoading = true;
        this.loadData();
      }
    }

    this.subscriptions.push(
      this.searchCtrl.valueChanges
        .pipe(debounceTime(400), distinctUntilChanged())
        .subscribe((val) => {
          this.onSearchChange(val);
        }),
    );
  }
  loadData(search?): void {
    let data: IListParams = {};

    if (!this.devFlag) {
      data = { limit: this.limit, skip: this.skip };
    }

    if (search) {
      data.search = search;
    }

    this._api.getWithUrl(this.endpoint, data).subscribe(
      (list) => {
        this.count = list.totalCount;

        if (!search) {
          this._api.lazyPaths
            .find((o) => o.name === this.type)
            .data.next(list.list);
          this._api.lazyPaths.find((o) => o.name === this.type).isLoading =
            false;
        } else {
          if (list.list instanceof Array) {
            this.list = this.list.concat(list.list);
          } else {
            this.list.push(list.list);
          }
        }
      },
      (err) => {
        console.log(err);
        // this._toastr.error('something went wrong..!')
      },
    );
  }
  loadnext(): void {
    if (this.list.length < this.count) {
      this.skip = this.skip + this.limit;
      this.loadData();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  change(e): void {
    if (this.list && this.list.length > 0 && e) {
      const selected = this.list.filter((el) => el._id === e)[0];

      this.changeValue.emit(selected);
    }

    this.onTouch(e);
    this.onChange(e);
  }

  onSearchChange(e): void {
    // this.search = e;
    this.skip = 0;

    let originalList = [];
    this.subscriptions.push(
      this._api.lazyPaths
        .find((o) => o.name === this.type)
        .data.subscribe((data) => (originalList = data)),
    );

    this.list = originalList;

    if (this.list && this.list.length > 0) {
      if (this.list[0].name) {
        this.list = this.list.filter(
          (item) => item.name.search(new RegExp(e, 'i')) > -1,
        );
      } else if (this.list[0].character) {
        this.list = this.list.filter(
          (item) => item.character.search(new RegExp(e, 'i')) > -1,
        );
      }
    } else {
      this.list = [];
    }

    // this.list = this.list
    //   ? this.list.filter(item => item.name.search(new RegExp(e, 'i')) > -1)
    //   : [];
    if (!e) {
      const isData = this.paths.find((o) => o.name === this.type).data;
      const isLoading = this.paths.find((o) => o.name === this.type).isLoading;
      this.subscriptions.push(
        this._api.lazyPaths
          .find((o) => o.name === this.type)
          .data.subscribe((data) => (this.list = data)),
      );

      if (this.endpoint && !isData.value && !isLoading) {
        this._api.lazyPaths.find((o) => o.name === this.type).isLoading = true;
        this.loadData();
      }
    }
  }

  getNextBatch(): void {
    this.loadnext();
    // console.log('nextBatch');
  }

  populatePreSelect(val): void {
    // console.log('populatepreSelect',this.selected,val);
    if (val) {
      // this.list.push(val);
      this.markDuplicate();
    }
  }
  markDuplicate(): void {
    // This was supposed for lazy loading of selectables
  }
}
